"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getConfig = require("./get-config");
var _sendMessage = require("./send-message");
var _validateConfig = require("./validate-config");
var _destroy = require("./command/destroy");
var _display = require("./command/display");
var _hide = require("./command/hide");
var _initialize = require("./command/initialize");
var _reinitialize = require("./command/reinitialize");
var _reset = require("./command/reset");
var _show = require("./command/show");
/*
* Copyright (c) 2018 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/
/**
 * Core SDK Bootstrap Script
 * - resident in partner "parent" DOM
 * - coordinates IFRAME element creation
 * - handles SDK initialization after IFRAME HTML load is complete
 * - handles messaging to SDK IFRAMES
 * - handles dispatch of messages from SDK IFRAMES
 * - manages multiple IFRAME instances
 *
 * @module core-bootstrap
 */
var _default = exports["default"] = {
  getConfig: _getConfig.getConfig,
  sendMessage: _sendMessage.sendMessage,
  validateConfig: _validateConfig.validateConfig,
  initialize: _initialize.initialize,
  reinitialize: _reinitialize.reinitialize,
  display: _display.display,
  show: _show.show,
  hide: _hide.hide,
  destroy: _destroy.destroy,
  reset: _reset.reset
};
//# sourceMappingURL=index.js.map